import React from 'react'
import { cn } from "../../../../lib/utils"

export default function THead({className, children}) {
  return (
    <thead className={cn(className)}>{children}</thead>
  )
}
